// extracted by mini-css-extract-plugin
export var attachButton = "_l9-8";
export var sendButton = "_l9-2";
export var sendDisabled = "_l9-4";
export var sendEnabled = "_l9-3";
export var sendIcon = "_l9-6";
export var sendIconDisabled = "_l9-7";
export var sendStreaming = "_l9-5";
export var textarea = "_l9-1";
export var wrapper = "_l9-0";